import {createSelector} from 'reselect';
import {RootState} from '../rootReducer';

export const specialistDashboardLoadingStatus = createSelector([(state: RootState) => state.specialistDashboard.isLoading], isLoading => isLoading);

export const specialistDashboardSuccessStatus = createSelector(
  [(state: RootState) => state.specialistDashboard.specialistDashboardSuccess],
  specialistDashboardSuccess => specialistDashboardSuccess,
);

export const specialistDashboardFailureStatus = createSelector(
  [(state: RootState) => state.specialistDashboard.specialistDashboardFailure],
  specialistDashboardFailure => specialistDashboardFailure,
);

export const specialistDashboardSubmitSecondOpinionLoadingStatus = createSelector(
  [(state: RootState) => state.specialistDashboard.submitSecondOpinionLoading],
  submitSecondOpinionLoading => submitSecondOpinionLoading,
);

/*
Consultation Selectors
*/
export const specialistDashboardConsultation = createSelector([(state: RootState) => state.specialistDashboard.consultation], consultation => consultation);

/*
Dashboard State Selectors
*/
export const specialistDashboardRating = createSelector([(state: RootState) => state.specialistDashboard.dashboardState.rating], rating => rating);

export const specialistDashboardTotalConsultationCase = createSelector(
  [(state: RootState) => state.specialistDashboard.dashboardState.total_consultation_case],
  total_consultation_case => total_consultation_case,
);

export const specialistDashboardTotalPendingCase = createSelector(
  [(state: RootState) => state.specialistDashboard.dashboardState.total_pending_case],
  total_pending_case => total_pending_case,
);

export const specialistDashboardTotalOngoingCount = createSelector(
  [(state: RootState) => state.specialistDashboard.dashboardState.total_ongoing_count],
  total_ongoing_count => total_ongoing_count ?? 0,
);

export const specialistDashboardOngoingConsultations = createSelector(
  [(state: RootState) => state.specialistDashboard.dashboardState.ongoing_consultations],
  ongoing_consultations => ongoing_consultations,
);

/*
Consultation List Selectors
*/
export const specialistConsultations = createSelector(
  [(state: RootState) => state.specialistDashboard.consultations.consultation],
  consultation => consultation,
);

export const specialistDashboardPendingCase = createSelector(
  [(state: RootState) => state.specialistDashboard.dashboardState.pending_case],
  pending_case => pending_case,
);

export const specialistDashboardRecentPatients = createSelector(
  [(state: RootState) => state.specialistDashboard.dashboardState.recent_patients],
  recent_patients => recent_patients,
);

export const specialistDashboardRecentFeedback = createSelector(
  [(state: RootState) => state.specialistDashboard.dashboardState.recent_feedback],
  recent_feedback => recent_feedback,
);

export const hasSpecialistConsultedBeforeSelector = createSelector(
  [(state: RootState) => state.specialistDashboard.dashboardState.has_consulted],
  has_consulted => has_consulted,
);

export const specialistConsultationTab = createSelector(
  [(state: RootState) => state.specialistDashboard.consultations.current_tab],
  current_tab => current_tab,
);

export const specialistConsultationsCurrentPage = createSelector(
  [(state: RootState) => state.specialistDashboard.consultations.currentPage],
  currentPage => currentPage,
);

export const specialistConsultationsNextPage = createSelector([(state: RootState) => state.specialistDashboard.consultations.nextPage], nextPage => nextPage);

export const specialistConsultationsTotalPages = createSelector(
  [(state: RootState) => state.specialistDashboard.consultations.totalPages],
  totalPages => totalPages,
);

export const specialistConsultationsTotalResults = createSelector(
  [(state: RootState) => state.specialistDashboard.consultations.totalResults],
  totalResults => totalResults,
);

export const specialistPatientDetails = createSelector([(state: RootState) => state.specialistDashboard.patientDetails], patientDetails => patientDetails);

export const specialistPatientDetailsLoadingStatus = createSelector(
  [(state: RootState) => state.specialistDashboard.patientDetailsLoading],
  patientDetailsLoading => patientDetailsLoading,
);

export const specialistConsultationAdditionalFilesLoadingStatus = createSelector(
  [(state: RootState) => state.specialistDashboard.consultationAdditionalFilesLoading],
  consultationAdditionalFilesLoading => consultationAdditionalFilesLoading,
);

export const specialistListForRefferal = createSelector([(state: RootState) => state.specialistDashboard.specialist_list], specialist_list => specialist_list);

/*
Payments Selectors
*/
export const specialistPayments = createSelector([(state: RootState) => state.specialistDashboard.payments.payments], payments => payments);

export const specialistPaymentsLoading = createSelector([(state: RootState) => state.specialistDashboard.payments.isLoading], isLoading => isLoading);

export const specialistPaymentsCurrentPage = createSelector([(state: RootState) => state.specialistDashboard.payments.currentPage], currentPage => currentPage);

export const specialistPaymentsTotalPages = createSelector([(state: RootState) => state.specialistDashboard.payments.totalPages], totalPages => totalPages);

export const specialistPaymentsTotalResults = createSelector(
  [(state: RootState) => state.specialistDashboard.payments.totalResults],
  totalResults => totalResults,
);

export const specialistPaymentsNextPage = createSelector([(state: RootState) => state.specialistDashboard.payments.nextPage], nextPage => nextPage);

export const specialistPaymentsErrorMessage = createSelector(
  [(state: RootState) => state.specialistDashboard.payments.errorMessage],
  errorMessage => errorMessage,
);

// Speech to Text Transcribe Selectors
export const transcribeAudioLoadingStatus = (state: RootState) =>
  state.specialistDashboard?.transcribeAudioLoading ?? false;

export const transcribedTextStatus = (state: RootState) =>
  state.specialistDashboard?.transcribedText;
